import clsx from "clsx";
import BenefitCard from "components/organism/Cards/BenefitCard";
import { SectionTitle, Subtitle } from "components/atoms/Text";
import Divider from "./Divider";
import DividerPhone from "./DividerPhone";

const Benefits = () => {
    return (
        <section className="benefits w-full max-w-[1440px] mx-auto phone:py-12 tablet:py-16 py-[88px]">
            <section className={clsx(
                "w-full mx-auto max-w-full tablet:max-w-[700px] desktop:max-w-[678px] text-center",
                "px-6 md:px-0"
            )}>
                <SectionTitle>Buy Dedicated HTTP Proxies</SectionTitle>
                <Subtitle classNames="max-w-[626px] tablet:max-w-[620px] mx-auto">Our entire infrastructure is built from the ground-up to ensure that our dedicated proxies are owned by a single entity making it impossible to allow any
                    mistakes or accidental sharing.</Subtitle>
            </section>
            <section className={clsx(
                "w-full max-w-[1440px] mx-auto mt-14 phone:mt-12",
                "px-6 tablet:px-8 bg-none w-full desktop:w-[994px]"
            )}>
                <div className="p-8 rounded-lg phone:px-6 shadow-smooth phone:py-0 bg-neutral-10 shadow-[0px 8px 100px 1px rgba(23, 43, 52, 0.04)] w-full mx-auto flex phone:flex-col items-center phone:justify-center gap-4 phone:gap-y-0 tablet:justify-between desktop:justify-between">
                    <BenefitCard title="Bandwidth & Domains" values="Unlimited" />
                    <Divider className="h-[56px] phone:hidden block" />
                    <DividerPhone className="hidden phone:block" />
                    <BenefitCard title="Concurrent Sessions" values="Unlimited" />
                    <Divider className="h-[56px] phone:hidden block" />
                    <DividerPhone className="hidden phone:block" />
                    <BenefitCard title="Subnets" values="7,850" />
                    <Divider className="h-[56px] phone:hidden block" />
                    <DividerPhone className="hidden phone:block" />
                    <BenefitCard title="Locations" values="1,880" />
                </div>
            </section>
        </section>
    );
};

export default Benefits;